var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-no-bind */
import { useLocalization } from '@shared-ui/localization-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { parse } from 'query-string';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkLoader } from 'uitk-react-loader';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';
import { ActivityMessageType } from '../../../../common/__generated__/api';
import { trackAction } from '../../../common/banners';
import { EgdsHeadingTagStyle, UITK_HEADING_SIZE } from '../../../../constants';
import { getPageId, getPageSize, getSeeAllURL } from '../../../../helpers/common-helper';
import { onClickScrollToTarget } from '../../../../helpers/smooth-scroll';
import { useStores } from '../../../../utils/hooks';
import { GridLayoutComponent } from './grid-layout-component';
var showMoreButtonProps = {
  margin: {
    blockstart: 'two',
    blockend: 'four'
  }
};
export var DestinationActivityList = function (props) {
  var _a = useStores(),
    analytics = _a.analytics,
    page = _a.page,
    activitySearchStore = _a.activitySearchStore,
    searchCriteriaStore = _a.searchCriteriaStore;
  var activityGroup = props.activityGroup,
    activityTiles = props.activityTiles,
    index = props.index;
  var formatText = useLocalization().formatText;
  var location = useLocation();
  var queryParams = parse(location.search);
  var focusList = React.createRef();
  var showMoreLoading = activitySearchStore.showMoreLoading,
    showMoreButton = activitySearchStore.showMoreButton;
  var seeAllLinkUrl = activityGroup.action ? getSeeAllURL(activityGroup.action.url, queryParams) : '';
  var showSeeAllButton = activityGroup.action ? activityGroup.action.url !== 'Show More' : false;
  var displayShowMoreButton = showMoreButton && activityGroup.action ? activityGroup.action.url === 'Show More' : false;
  var heading = activityGroup.heading;
  React.useEffect(function () {
    var _a;
    var sourcedCampaignMsg = activityTiles.find(function (tile) {
      return tile.type === ActivityMessageType.SOURCED_CAMPAIGN;
    });
    if ((_a = sourcedCampaignMsg === null || sourcedCampaignMsg === void 0 ? void 0 : sourcedCampaignMsg.analytics) === null || _a === void 0 ? void 0 : _a.referrerId) {
      trackAction(sourcedCampaignMsg.analytics.referrerId, sourcedCampaignMsg.analytics.linkName, analytics, []);
    }
    if ((focusList === null || focusList === void 0 ? void 0 : focusList.current) && searchCriteriaStore.activityToFocus.index !== null) {
      searchCriteriaStore.activityToFocus.element = focusList.current.querySelectorAll('a[data-testid="card-link"]')[searchCriteriaStore.activityToFocus.index];
    }
  });
  var handleSrpTileClick = function (activityTile, tileIndex) {
    searchCriteriaStore.scrollPosition = window.pageYOffset;
    searchCriteriaStore.activityToFocus.index = tileIndex;
    if (activityTile.clientSideAnalytics) {
      analytics.trackEvent(activityTile.clientSideAnalytics.referrerId, activityTile.clientSideAnalytics.linkName, analytics.omnitureData);
    }
  };
  var handleShowAllClick = function (action) {
    onClickScrollToTarget({
      scrollTo: 0
    });
    analytics.trackEvent(action.analytics.referrerId, action.analytics.linkName, analytics.omnitureData);
  };
  var getActivityTiles = function (tiles, activityGroupName) {
    var cardLayoutComponentProps = {
      activityTiles: tiles,
      loading: false,
      onClick: handleSrpTileClick,
      activityGroup: activityGroupName
    };
    return React.createElement(GridLayoutComponent, __assign({}, cardLayoutComponentProps));
  };
  var getSeeAllButton = function (seeAllUrl, activityGroupAction, isFullWidth) {
    return React.createElement(UitkSecondaryButton, {
      isFullWidth: isFullWidth,
      tag: "a",
      "data-testid": "destination-activity-list-see-all",
      onClick: handleShowAllClick.bind(null, activityGroupAction),
      href: seeAllUrl,
      rel: "noopener noreferrer"
    }, React.createElement("span", {
      "aria-hidden": Boolean(activityGroupAction.accessibilityText)
    }, activityGroupAction.label), React.createElement("span", null, activityGroupAction.accessibilityText && React.createElement("span", {
      className: "is-visually-hidden"
    }, activityGroupAction.accessibilityText)));
  };
  var showMore = function () {
    var pageId = getPageId(activitySearchStore);
    var pageSize = getPageSize(activitySearchStore);
    var pageIndex = searchCriteriaStore.getPaginationIndex;
    analytics.trackEvent("LX.".concat(pageId, ".ShowMore"), 'show-more', analytics.omnitureData);
    searchCriteriaStore.showMore();
    searchCriteriaStore.scrollPosition = window.pageYOffset;
    searchCriteriaStore.activityToFocus.index = pageIndex * pageSize - 1;
    activitySearchStore.showMoreLoading = true;
    activitySearchStore.fetchActivitiesSearchDestinationView(searchCriteriaStore, analytics, {}, searchCriteriaStore.currentSearchVariables, page.pageId, index, false, false);
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    id: "activity-list-".concat(index),
    className: "activity-list",
    "data-testid": "destination-activity-list--section"
  }, React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'six',
      blockend: 'three'
    }
  }, React.createElement("div", {
    ref: focusList
  }, (heading === null || heading === void 0 ? void 0 : heading.text) && React.createElement(UitkSpacing, {
    margin: {
      blockend: 'three'
    },
    padding: {
      small: {
        blockstart: 'three'
      },
      medium: {
        blockstart: 'four'
      }
    }
  }, React.createElement(UitkHeading, {
    tag: heading.headingType ? EgdsHeadingTagStyle[heading.headingType] : 'h2',
    size: UITK_HEADING_SIZE
  }, heading.text)), activityTiles && getActivityTiles(activityTiles, heading === null || heading === void 0 ? void 0 : heading.text.split(' ').join('')), activityGroup.action && showSeeAllButton && React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'two'
    }
  }, React.createElement("div", {
    className: "uitk-link-align-center"
  }, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(React.Fragment, null, getSeeAllButton(seeAllLinkUrl, activityGroup.action, false))), React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, getSeeAllButton(seeAllLinkUrl, activityGroup.action, true))))))))), displayShowMoreButton && React.createElement(UitkSpacing, {
    margin: showMoreButtonProps.margin
  }, React.createElement("div", {
    className: "uitk-type-center"
  }, showMoreLoading && React.createElement(UitkLoader, {
    className: "view-all"
  }), React.createElement(UitkSecondaryButton, {
    "data-testid": "destination-activity-list-show-more",
    disabled: showMoreLoading,
    onClick: showMore
  }, formatText('lx.search.activityList.showMoreButton')))));
};